import { Typography } from "antd";
import PropTypes from "prop-types";

import { TABLE_TITLE_COLUMN_TEXT } from "@/constants/Typography";

const { Text } = Typography;

const TableTitleCell = ({ tooltip, maxWidth, children }) => {
  if (!children) return null;

  return (
    <Text
      ellipsis={{ tooltip }}
      style={{ maxWidth: maxWidth ?? TABLE_TITLE_COLUMN_TEXT.MAX_WIDTH }}
    >
      {children}
    </Text>
  );
};

TableTitleCell.propTypes = {
  tooltip: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableTitleCell;
